import { createSettings } from "kanopi-components/createSettings";

type EnvConfig = {
  GOOGLE_MAPS_API_KEY: string;
  FIN_ADDRESS_API_KEY: string;
  SEGMENT_API_KEY: string;
  STRIPE_API_KEY: string;
  STAGE_TYPE: string;
  GIT_REVISION: string;
  DATADOG_RUM_CLIENT_TOKEN: string;
  DATADOG_RUM_APP_ID: string;
  DATADOG_LOG_CLIENT_TOKEN: string;
  STATSIG_SDK_KEY: string;
  KANOPI_AUTH_URL: string;
};

export const config: EnvConfig = {
  STAGE_TYPE: window.settings.STAGE_TYPE ?? "unknown",
  GIT_REVISION: window.settings.GIT_REVISION ?? "unknown",
  GOOGLE_MAPS_API_KEY: window.settings.GOOGLE_MAPS_API_KEY ?? "unknown",
  FIN_ADDRESS_API_KEY: window.settings.FIN_ADDRESS_API_KEY ?? "unknown",
  SEGMENT_API_KEY: window.settings.SEGMENT_API_KEY ?? "unknown",
  STRIPE_API_KEY: window.settings.STRIPE_API_PUBLIC_KEY ?? "unknown",
  DATADOG_LOG_CLIENT_TOKEN: "pub6eb1f4afbd15bb98024662ae16db235f", // public & always the same per env  https://app.datadoghq.com/rum/application/bc7dabe1-e0dd-4c3b-aaff-36fe789e0817/edit?integration=javascript
  DATADOG_RUM_CLIENT_TOKEN: "pub60ab1c036ddca4189eec4015cb49cc55", // public & always the same per env  https://app.datadoghq.com/rum/application/bc7dabe1-e0dd-4c3b-aaff-36fe789e0817/edit?integration=javascript
  DATADOG_RUM_APP_ID: "bc7dabe1-e0dd-4c3b-aaff-36fe789e0817", // public & always the same per env https://app.datadoghq.com/rum/application/bc7dabe1-e0dd-4c3b-aaff-36fe789e0817/edit?integration=javascript
  STATSIG_SDK_KEY: "client-7W66KHTRD7W0akDukB71hyTDXGEMeXOvzby9ckFWlCl", // public & always the same per env https://console.statsig.com/36e9AkPtVjDFJtEvDfRcII/api_keys
  KANOPI_AUTH_URL: window.settings.KANOPI_AUTH_URL ?? "unknown", // typically auth.{kanopi-domain}.com
};

const settings = createSettings({
  GOOGLE_MAPS_API_KEY: window.settings.GOOGLE_MAPS_API_KEY,
  FIN_ADDRESS_API_KEY: window.settings.FIN_ADDRESS_API_KEY,
  SEGMENT_API_KEY: window.settings.SEGMENT_API_KEY,
  STRIPE_API_KEY: window.settings.STRIPE_API_PUBLIC_KEY,
  STAGE_TYPE: window.settings.STAGE_TYPE,
  GIT_REVISION: process.env.GIT_REVISION ?? "unknown",
  KANOPI_AUTH_URL: window.settings.KANOPI_AUTH_URL,
});

globalThis.settings = settings;

export default settings;
